import { useTheme } from 'styled-components'

import { Logo } from '@/modules/shared/components/logo'
import { ImageBackground } from '../image-background/ImageBackground'
import {
  FloatingLayoutContainer,
  FloatingLayoutContent,
  FloatingLayoutContentContainer,
  FloatingLayoutLogo,
} from './FloatingLayout.styled'

import type { ReactNode } from 'react'

type FloatingLayoutProps = {
  children?: ReactNode
  backgroundColor?: string
  image: string
  imageGridColumns: string
  imagePosition?: string
}

const FloatingLayout = ({ children, backgroundColor, image, imageGridColumns, imagePosition }: FloatingLayoutProps) => {
  const theme = useTheme()

  return (
    <FloatingLayoutContainer>
      <FloatingLayoutLogo>
        <Logo />
      </FloatingLayoutLogo>
      <FloatingLayoutContentContainer>
        <FloatingLayoutContent>{children}</FloatingLayoutContent>
      </FloatingLayoutContentContainer>

      <ImageBackground
        image={image}
        backgroundColor={backgroundColor ?? theme.Colors.Background.Light}
        gridColumns={imageGridColumns}
        imagePosition={imagePosition}
      />
    </FloatingLayoutContainer>
  )
}

export { FloatingLayout }
